/* eslint-disable */
import {
  GET_ALL_UNREAD_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
  name: 'SystemNotifications',
  mixins: [alert_mixin],
  props: {
      show: {
          type: Boolean,
          required: true
      }
  },
  data: () => ({
    headers: get_headers(),
    token: get_token(),
    project_id: get_project_id(),
    notifications: [],
    loading: false
  }),
  computed: {
    unread_count() {
      const count = this.notifications.filter(n => !n.is_read).length;
      this.$emit('update-unread-count', count);
      return count;
    }
  },
  mounted() {
      this.get_unread_notifications();
  },
  methods: {
    get_unread_notifications() {
      const project_id = this.project_id;

      const query_params = { project_id: project_id };
      axios.get(GET_ALL_UNREAD_NOTIFICATIONS, { headers: this.headers, params: query_params })
        .then(response => {
          this.notifications = response.data.data.map(notification => ({
            ...notification,
            content_type: notification.content_type,
            verb: notification.verb,
            object_id: notification.object_id || null,
            time: this.format_time(notification.created_at),
            data: notification.data || {},
            is_read: notification.is_read || false
          }));

          const unread_count = this.notifications.filter(n => !n.is_read).length;
          this.$emit('update-unread-count', unread_count);
        })
        .catch(error => {
          this.$emit('update-unread-count', 0);
        });
    },

    mark_single_notification_as_read(notification) {
      if (notification.is_read) return;

      const params = {
        notification_id: notification.id
      };

      axios.post(
        MARK_NOTIFICATION_READ,
        params,
        { headers: this.headers }
      )
      .then(response => {
        if (response.data.status === 'success') {
        notification.is_read = true;
        this.$emit('update-unread-count', this.unread_count);
      }
      })
      .catch(error => {
        this.show_error('Failed to mark notification as read' || error.response ? error.response.data : error);
      });
    },

    format_time(date_string) {
      const now = new Date();
      const date = new Date(date_string);
      const diff_in_seconds = Math.floor((now - date) / 1000);

      if (diff_in_seconds < 60) return `${diff_in_seconds} seconds ago`;
      if (diff_in_seconds < 3600) return `${Math.floor(diff_in_seconds / 60)} minutes ago`;
      if (diff_in_seconds < 86400) return `${Math.floor(diff_in_seconds / 3600)} hours ago`;

      return date.toLocaleDateString();
    },

    view_notification(notification) {
      this.mark_single_notification_as_read(notification);
      this.$emit('view-notification', notification);
      this.handle_notification_redirect(notification);
      this.close();
    },

    handle_notification_redirect(notification) {
      const redirect_rules = {
        'enquirymessage': {
          'New chat message': () => {
            if (notification.data?.lead_id) {
              this.$router.push(`/leads_responses/${notification.data.lead_id}`);
            } else {
              this.$router.push('/leads_management');
            }
          }
        },
        'lead': {  // Keep this as fallback
          'New enquiry submitted': () => this.$router.push('/leads_management')
        }
      };

      // Try exact content_type match first, then fallback
      const handler = redirect_rules[notification.content_type]?.[notification.verb] ||
                     redirect_rules['lead']?.[notification.verb] ||
                     (() => this.$router.push('/dashboard'));

      try {
        handler();
      } catch (error) {
        this.$router.push('/dashboard');
      }
    },

    get_content_type_label(content_type) {
      const labels = {
        'lead': 'Lead',
        'task': 'Task',
      };
      return labels[content_type] || content_type;
    },

    close() {
      this.$emit('close');
    }
  }
}